import { useEffect } from "react";
import { useResetHash } from "@/shared/hooks/useResetHash";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useGetTranscript } from "./api/useGetTranscript";
import TranscriptContent from "./components/TranscriptContent";
import { Loader2 } from "lucide-react";

interface ViewTranscriptModalProps {
  id: number | null;
  chunkId?: number;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function ViewTranscriptModal({
  id,
  chunkId,
  open,
  onOpenChange,
}: ViewTranscriptModalProps) {
  const { transcript, getTranscript, isLoading } = useGetTranscript();

  useEffect(() => {
    if (open && id) {
      getTranscript(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, open]);

  useResetHash(transcript);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl h-[80vh]">
        <DialogHeader>
          <DialogTitle>{transcript?.title || "Transcript Details"}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto">
          {isLoading && (
            <div className="flex items-start justify-center pt-4">
              <Loader2 className="h-8 w-8 animate-spin text-gray-400" />
            </div>
          )}
          {transcript && (
            <TranscriptContent transcript={transcript} chunkId={chunkId} />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
